import { ProcedureMapEnum } from '../../models/procedure-map.enum';
import { MaterialEnum } from '../../models/material.enum';
import { SpecificationEnum } from '../../models/specification.enum';
import { UnitTypes } from '@modules/teeth-diagram/models/unit-type.enum';
import { ProcedureSpecificationMaterialRule } from '../../models/specification-material-rules-config';

const baseCrownImplantBasedMaterials: readonly MaterialEnum[] = [
	MaterialEnum.CeramicZirconia,
	MaterialEnum.CeramicTranslucentZirconia,
	MaterialEnum.CeramicMultilayerZirconia,
	MaterialEnum.CeramicLithiumDisilicate,
	MaterialEnum.CeramicLithiumSilicate,
	MaterialEnum.CeramicGlassCeramic,
	MaterialEnum.CeramicFeldspathicCeramic,
	MaterialEnum.CeramicHybrid,
	MaterialEnum.CeramicLabPreference,
	MaterialEnum.ResinAcrylicPMMA,
	MaterialEnum.Composite,
	MaterialEnum.OtherCheckNote
];

const baseInlayOnlayMaterials: readonly MaterialEnum[] = [
	MaterialEnum.CeramicLithiumDisilicate,
	MaterialEnum.CeramicLithiumSilicate,
	MaterialEnum.CeramicGlassCeramic,
	MaterialEnum.CeramicFeldspathicCeramic,
	MaterialEnum.CeramicHybrid,
	MaterialEnum.CeramicLabPreference,
	MaterialEnum.Composite,
	MaterialEnum.OtherCheckNote
];

export const rulesForFixedRestorativeGlidewellIo: ProcedureSpecificationMaterialRule = {
	ProcedureMaps: [ProcedureMapEnum.FixedRestorativeGlidewellIo],
	UnitTypeRules: [
		{
			Id: UnitTypes.Crown,
			Specifications: [
				{
					Id: SpecificationEnum.None,
					Materials: [...baseCrownImplantBasedMaterials]
				}
			]
		},
		{
			Id: UnitTypes.ImplantBased,
			Specifications: [
				{
					Id: SpecificationEnum.None,
					Materials: [...baseCrownImplantBasedMaterials]
				}
			]
		},
		{
			Id: UnitTypes.Inlay,
			Specifications: [
				{
					Id: SpecificationEnum.None,
					Materials: [...baseInlayOnlayMaterials]
				}
			]
		},
		{
			Id: UnitTypes.Onlay,
			Specifications: [
				{
					Id: SpecificationEnum.None,
					Materials: [...baseInlayOnlayMaterials]
				}
			]
		}
	]
};
